import fetch from '@/utils/fetch';

export default {
  // 保存报名信息
  saveCompetitionRegistration: data => {
    return fetch({
      url: 'competition-registration/save',
      method: 'post',
      data
    })
  },
  // 获取报名信息
  getCompetitionRegistration: params => {
    return fetch({
      url: 'inquiry/competition-registration',
      method: 'get',
      params
    })
  },
  // 保存参赛作品信息
  saveProject: data => {
    return fetch({
      url: 'competition-projects/save',
      method: 'post',
      data
    })
  },
  // 获取单个参赛作品信息
  getOneProject: id => {
    return fetch({
      url: `inquiry/competition-projects/${id}`,
      method: 'get'
    })
  },
  // 获取参赛作品列表
  getProjects: params => {
    return fetch({
      url: 'inquiry/competition-projects',
      method: 'get',
      params
    })
  },
  // 删除单个参赛作品
  deleteOneProject: id => {
    return fetch({
      url: `competition-projects/${id}`,
      method: 'delete'
    })
  },
  // 获取奖项类型
  getAwardTypes: params => {
    return fetch({
      url: 'inquiry/award-types',
      method: 'get',
      params
    })
  },
  // 获取大赛信息
  getOneCompetition: id => {
    return fetch({
      url: `inquiry/competitions/${id}`,
      method: 'get'
    })
  },

  // 保存事件信息
  saveTopEvent: data => {
    return fetch({
      url: 'competition-event/save',
      method: 'post',
      data
    })
  },
  // 删除单个事件
  deleteOneTopEvent: id => {
    return fetch({
      url: `competition-event/${id}`,
      method: 'delete'
    })
  },
  // 审核事件
  checkTopEvent: data => {
    return fetch({
      url: 'competition-event/check',
      method: 'put',
      data
    })
  },
  // 获取事件列表
  getTopEvent: params => {
    return fetch({
      url: 'inquiry/competition-event',
      method: 'get',
      params
    })
  },
  // 获取事件信息
  getOneTopEvent: id => {
    return fetch({
      url: `inquiry/competition-event/${id}`,
      method: 'get',
    })
  },
  // 获取事件评论列表
  getTopEventComment: params => {
    return fetch({
      url: 'inquiry/competition-event-comment',
      method: 'get',
      params
    })
  },
  // 保存事件评论信息
  saveTopEventComment: data => {
    return fetch({
      url: 'competition-event-comment/save',
      method: 'post',
      data
    })
  },
  // 删除单条评论
  deleteOneTopEventComment: id => {
    return fetch({
      url: `competition-event-comment/${id}`,
      method: 'delete'
    })
  },
  // 获取事件投票信息
  getTopEventVote: params => {
    return fetch({
      url: 'inquiry/competition-event-vote',
      method: 'get',
      params
    })
  },
  // 保存事件投票信息
  saveTopEventVote: data => {
    return fetch({
      url: 'competition-event-vote/save',
      method: 'post',
      data
    })
  },

}